import React from 'react'

import { Container } from './tdContentStyles'

interface TDContentProps {
    text: string
    additionalContent?: React.ReactNode
    position?: 'bottom' | 'right' | 'left'
}

export function TDContent({ text, additionalContent, position = 'bottom' }: TDContentProps) {
    return (
        <Container position={position}>
            {position === 'left' && <>{additionalContent}</>}
            <span>{text}</span>
            {position !== 'left' && <>{additionalContent}</>}
        </Container>
    )
}
